import script from "./RelatedLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatedLinks.vue?vue&type=script&setup=true&lang=js"

import "./RelatedLinks.vue?vue&type=style&index=0&id=14958b46&lang=scss"

const __exports__ = script;

export default __exports__